import apiClient, { extractData } from '../api-client';

export const orderMessageTemplateApi = {
  list() {
    return apiClient.get('/order-message-templates').then(extractData);
  },
  getByStatus(status) {
    return apiClient.get(`/order-message-templates/${status}`).then(extractData);
  },
  update(status, data) {
    return apiClient.patch(`/order-message-templates/${status}`, data).then(extractData);
  },
  getShippingGuide() {
    return apiClient.get('/order-message-templates/shipping-guide').then(extractData);
  },
  uploadShippingGuide(file) {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient
      .post('/order-message-templates/shipping-guide', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then(extractData);
  },
};
